import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=343daa3c&scoped=true&"
import script from "./phone.vue?vue&type=script&lang=js&"
export * from "./phone.vue?vue&type=script&lang=js&"
import style0 from "./phone.vue?vue&type=style&index=0&id=343daa3c&prod&scoped=true&lang=css&"
import style1 from "./phone.vue?vue&type=style&index=1&id=343daa3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343daa3c",
  null
  
)

export default component.exports